export default __webpack_public_path__ + "static/media/trash-icon.750d3d28.svg";